/* @flow */
import ApplicationNetworks from './application_networks'
import Gateways from './gateways'
import EndDevices from './end_devices'
import DeviceProfiles from './device_profiles'
import NetworkProfiles from './network_profiles'
import Packets from './packets'
import JoinRequests from './join_requests'
import GatewayStatistics from './gateway_statistics'
import NetworkStatistics from './network_statistics'
import Users from './users'
import Organizations from './organizations'
import DeviceGroups from './device_groups'
import Policies from './policies'
import SystemThresholds from './system_thresholds'

export default {
  modules: {
    application_networks: ApplicationNetworks,
    gateways: Gateways,
    end_devices: EndDevices,
    device_profiles: DeviceProfiles,
    network_profiles: NetworkProfiles,
    packets: Packets,
    join_requests: JoinRequests,
    gateway_statistics: GatewayStatistics,
    network_statistics: NetworkStatistics,
    users: Users,
    organizations: Organizations,
    device_groups: DeviceGroups,
    policies: Policies,
    system_thresholds: SystemThresholds
  },
}



// WEBPACK FOOTER //
// ./src/store/entities.js